import { QueryClientProvider } from '@tanstack/react-query';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter as Router } from 'react-router-dom';
import { queryClient } from '../core/network/queryClient';
import { TheLayout } from './layout';
import i18n from '../core/locales/i18n';
import './App.less';

// Mọi API của app đều là REST public, gọi qua restClient + TanStack Query
export function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <Router>
          <TheLayout />
        </Router>
      </QueryClientProvider>
    </I18nextProvider>
  );
}
export default App;
